var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExcelColorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23.467,
    height: 21.791,
    viewBox: "0 0 23.467 21.791",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.174,
    y1: -146.919,
    x2: 0.826,
    y2: -145.787,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#18884f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#117e43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0b6631"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "excel-svgrepo-com",
    transform: "translate(-2 -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1754",
    "data-name": "Path 1754",
    d: "M17.789,15.034,8.512,13.4V25.476a1,1,0,0,0,1,1H25.52a1,1,0,0,0,1-1h0V21.027Z",
    transform: "translate(-1.054 -1.684)",
    fill: "#185c37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1755",
    "data-name": "Path 1755",
    d: "M17.789,3H9.512a1,1,0,0,0-1,1h0V8.448L17.789,13.9,22.7,15.53l3.82-1.634V8.448Z",
    transform: "translate(-1.054 0)",
    fill: "#21a366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1756",
    "data-name": "Path 1756",
    d: "M8.512,9.5h9.277v5.448H8.512Z",
    transform: "translate(-1.054 -1.052)",
    fill: "#107c41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1757",
    "data-name": "Path 1757",
    d: "M15.151,8.2H8.512V21.819h6.639a1.006,1.006,0,0,0,1-1V9.2A1.006,1.006,0,0,0,15.151,8.2Z",
    transform: "translate(-1.054 -0.842)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1758",
    "data-name": "Path 1758",
    d: "M14.606,8.85H8.512V22.469h6.094a1.006,1.006,0,0,0,1-1V9.848a1.006,1.006,0,0,0-1-1Z",
    transform: "translate(-1.054 -0.947)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1759",
    "data-name": "Path 1759",
    d: "M14.606,8.85H8.512V21.38h6.094a1.006,1.006,0,0,0,1-1V9.848a1.006,1.006,0,0,0-1-1Z",
    transform: "translate(-1.054 -0.947)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1760",
    "data-name": "Path 1760",
    d: "M14.06,8.85H8.512V21.38H14.06a1.006,1.006,0,0,0,1-1V9.848A1.006,1.006,0,0,0,14.06,8.85Z",
    transform: "translate(-1.054 -0.947)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1761",
    "data-name": "Path 1761",
    d: "M3,8.85H13.006a1,1,0,0,1,1,1v9.988a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1V9.848a1,1,0,0,1,1-1Z",
    transform: "translate(0 -0.947)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1762",
    "data-name": "Path 1762",
    d: "M5.7,18.619l2.1-3.255L5.877,12.127H7.425L8.477,14.2a4.03,4.03,0,0,1,.2.439H8.69c.069-.158.142-.309.218-.458l1.125-2.051h1.425L9.481,15.349l2.027,3.273H9.992L8.777,16.349a1.974,1.974,0,0,1-.143-.306h-.02a1.415,1.415,0,0,1-.141.294L7.221,18.619Z",
    transform: "translate(-0.599 -1.478)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1763",
    "data-name": "Path 1763",
    d: "M27.312,3H19.581V8.448h8.732V4a1,1,0,0,0-1-1Z",
    transform: "translate(-2.846 0)",
    fill: "#33c481"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1764",
    "data-name": "Path 1764",
    d: "M19.581,16h8.732v5.448H19.581Z",
    transform: "translate(-2.846 -2.105)",
    fill: "#107c41"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcelColorIcon);
export default __webpack_public_path__ + "static/media/excel-color-icon.ef155e453801d12309f10bedbeb127ee.svg";
export { ForwardRef as ReactComponent };